export type ConfigType = {
  classCount: number;
  minLength: number;
  usePasswordStrength?: boolean;
};

export interface RuleType {
  label: string;
  validator: (pw: string) => boolean;
}

export interface TestResultType extends RuleType {
  passed: boolean;
}

export const configIsValid = (
  toBeDetermined: ConfigType | undefined,
): toBeDetermined is ConfigType => {
  if (toBeDetermined.classCount !== undefined) {
    return true;
  }
  return false;
};
